var map = {
	"./aleksanrd-stahurskiy.jpg": 31002,
	"./ekaterina-smirnova.jpg": 76775,
	"./review-alexandr.png": 88514,
	"./review-veronika.png": 85689,
	"./svetlana-mardanova.jpg": 26581
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56276;